import { render, staticRenderFns } from "./RecoveryError.vue?vue&type=template&id=8d387c52&"
import script from "./RecoveryError.vue?vue&type=script&lang=js&"
export * from "./RecoveryError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports